<template>
        <el-dialog title="新增" v-model="editFormVisible" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="姓名" prop="FName">
                    <el-input v-model="form.FName"></el-input>
                </el-form-item>
                  <el-form-item label="工号" prop="FCode">
                    <el-input v-model="form.FCode"></el-input>
                </el-form-item>
                <el-form-item v-if="!homeEdit" label="密码">
                    <el-input type="password" v-model="form.FPassWord" placeholder="********"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="FSex">
                    <el-radio-group v-model="form.FSex">
                        <el-radio :label="1" >男</el-radio>
                        <el-radio :label="0" >女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="电话号码" prop="FPhone">
                    <el-input v-model="form.FPhone"></el-input>
                </el-form-item>
                <el-form-item v-if="form.FID>=0" label="所属部门" prop="FDeptID">
                    <sy-select v-model="form.FDeptID" style="width:100%"
                                 optionData="server/system/Dept.ashx?cmd=GetOptions">
                    </sy-select>
                </el-form-item>
                <el-form-item label="角色" prop="FRoleID"> 
                    <sy-select v-model="form.FRoleID"
                               optionData="server/system/Role.ashx?cmd=GetOptionsStaff">
                    </sy-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
      </el-dialog>
</template>

<script>
    import util from '../../common/util'
    export default {
        props:{
            homeEdit:Boolean
        },
        data() {
            return {
                form: {},
                depts:[],
                rules: {
                    FName: [{required: true,message: '请输入姓名', trigger: 'blur'}],
                     FPhone: [{required: true,message: '请输入电话号码', trigger: 'blur'}],
                },
                loading:false,
                editFormVisible:false
            }
        },
        methods: {
            switchLoading(flag){
                this.loading = flag
            },
            _openEdit(record) {
                this.editFormVisible = true
                this.form = Object.assign({},record)
                /*if(this.form.FDeptLabel) {
                    this.depts=this.form.FDeptLabel.split(',').map(function(data){
                        return +data;
                    });
                }
                else{
                    this.depts =[]
                }
                console.log(this.depts)*/
            },
            _openAdd(record) {
                this.editFormVisible = true
                this.form = {FID:0,FType:2,FDeptID:0,FSex:null,FRoleID:1}
                if(record && record.FDeptID){
                    this.form.FDeptID = record.FDeptID
                    this.form.FDeptLabel = record.FDeptLabel
                }
               /* if(this.form.FDeptLabel) {
                    this.depts=this.form.FDeptLabel.split(',').map(function(data){
                        return +data;
                    });
                }
                else{
                    this.depts =[]
                }*/
            },
            save:function () {
               /* if(this.depts.length>0){
                    this.form.FDeptID = this.depts[this.depts.length-1]
                }
                else{
                    util.msgWarning("请填写所属部门")
                    return
                }*/
                util.saveForm("server/system/Staff.ashx?cmd=SaveStaff",this.$refs.form,this.form,this.switchLoading,result=> {
                    util.msgSuc("保存成功")
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/Staff_Edit.vue